import $ from 'jquery'
import 'bootstrap/js/src/index.js'
import '../../plugin/bootstrap-tileslide/js/index.js'

window.$ = window.jQuery = $;